/* eslint-disable max-len */
import React from 'react'
import PropTypes from 'prop-types'
import Tilt from 'react-tilt'

const TeamComponent = ({
    image,
    title,
    name,
    description,
    alt,
}) => (
    <div className="team-component">
        <div className="team-image-container">
            <Tilt className="Tilt" options={{ max: 25 }}>
                <img
                    src={image}
                    alt={alt}
                    className="image"
                    width="100%"
                    height="auto"
                />
            </Tilt>
        </div>
        <div className="team-text">
            <h3 className="team-name">{name}</h3>
            <h4 className="team-title">{title}</h4>
            <p>{description}</p>
        </div>
    </div>
)

TeamComponent.propTypes = {
    image: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
}

export default TeamComponent
